import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customMenu": null,
  "customPath": "/service/manual",
  "description": "Скачайте руководства пользователя и другую бортовую документацию к автомобилю ŠKODA. Чтобы найти документацию, пожалуйста, выберите модель автомобиля.",
  "huggerTemplate": "default",
  "keywords": "",
  "name": "manual",
  "title": "Руководства по эксплуатации автомобилей ŠKODA – скачать инструкции по эксплуатации"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const ListMobileSlider = makeShortcode("ListMobileSlider");
const ListItem = makeShortcode("ListItem");
const ListItemImage = makeShortcode("ListItemImage");
const ListItemHeader = makeShortcode("ListItemHeader");
const ListItemLink = makeShortcode("ListItemLink");
const DefSectionBtnContainer = makeShortcode("DefSectionBtnContainer");
const Button = makeShortcode("Button");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="center" horizontalAlign="left" src="/m/manual-home-banner.jpg" mobileSrc="/m/manual-home-banner-mob.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading">РУКОВОДСТВА ПО ЭКСПЛУАТАЦИИ</SimpleMainStageHeading>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionText mdxType="DefaultSectionText">
    Мы предоставляем Вам возможность просмотреть или скачать и распечатать
    руководства пользователя и другую бортовую документацию к Вашему автомобилю.
    Чтобы найти необходимую документацию, пожалуйста, выберите модель
    автомобиля.
  </DefaultSectionText>
    </DefaultPaddedSection>
    <div id="manuals"></div>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Руководства по эксплуатации</DefaultSectionHeading>
  <ListMobileSlider mdxType="ListMobileSlider">
    <ListItem mdxType="ListItem">
      <ListItemImage src="/m/kodiak-manual.jpg" mdxType="ListItemImage" />
      <ListItemHeader mdxType="ListItemHeader">KODIAQ</ListItemHeader>
      <ListItemLink hoverVisible size="small" href="/service/manual/kodiaq" mdxType="ListItemLink">
        Открыть
      </ListItemLink>
    </ListItem>
    <ListItem mdxType="ListItem">
      <ListItemImage src="/m/karoq-manual-new.png" mdxType="ListItemImage" />
      <ListItemHeader mdxType="ListItemHeader">KAROQ</ListItemHeader>
      <ListItemLink hoverVisible size="small" href="/service/manual/karoq" mdxType="ListItemLink">
        Открыть
      </ListItemLink>
    </ListItem>
    <ListItem mdxType="ListItem">
      <ListItemImage src="/m/superb-manual.jpg" mdxType="ListItemImage" />
      <ListItemHeader mdxType="ListItemHeader">SUPERB</ListItemHeader>
      <ListItemLink hoverVisible size="small" href="/service/manual/superb" mdxType="ListItemLink">
        Открыть
      </ListItemLink>
    </ListItem>
    <ListItem mdxType="ListItem">
      <ListItemImage src="/m/octavia-manual-new.jpg" mdxType="ListItemImage" />
      <ListItemHeader mdxType="ListItemHeader">OCTAVIA</ListItemHeader>
      <ListItemLink hoverVisible size="small" href="/service/manual/octavia" mdxType="ListItemLink">
        Открыть
      </ListItemLink>
    </ListItem>
    <ListItem mdxType="ListItem">
      <ListItemImage src="/m/rapid-manual-new.jpg" mdxType="ListItemImage" />
      <ListItemHeader mdxType="ListItemHeader">RAPID</ListItemHeader>
      <ListItemLink hoverVisible size="small" href="/service/manual/rapid" mdxType="ListItemLink">
        Открыть
      </ListItemLink>
    </ListItem>
    <ListItem mdxType="ListItem">
      <ListItemImage src="/m/yeti-manual.jpg" mdxType="ListItemImage" />
      <ListItemHeader mdxType="ListItemHeader">YETI</ListItemHeader>
      <ListItemLink hoverVisible size="small" href="/service/manual/yeti" mdxType="ListItemLink">
        Открыть
      </ListItemLink>
    </ListItem>
    <ListItem mdxType="ListItem">
      <ListItemImage src="/m/roomster-manual.jpg" mdxType="ListItemImage" />
      <ListItemHeader mdxType="ListItemHeader">ROOMSTER</ListItemHeader>
      <ListItemLink hoverVisible size="small" href="/service/manual/roomster" mdxType="ListItemLink">
        Открыть
      </ListItemLink>
    </ListItem>
    <ListItem mdxType="ListItem">
      <ListItemImage src="/m/fabia-manual.jpg" mdxType="ListItemImage" />
      <ListItemHeader mdxType="ListItemHeader">FABIA</ListItemHeader>
      <ListItemLink hoverVisible size="small" href="/service/manual/fabia" mdxType="ListItemLink">
        Открыть
      </ListItemLink>
    </ListItem>
  </ListMobileSlider>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">ŠKODA СТРАХОВАНИЕ</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    ŠKODA Insurance — это программа страхования для владельцев новых автомобилей
    ŠKODA. Ее отличительными особенностями являются привлекательные условия и
    широкий спектр дополнительных услуг.
  </DefaultSectionText>
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button href="/purchase/financial/insurance" mdxType="Button"> Подробнее </Button>
  </DefSectionBtnContainer>
    </DefaultPaddedSection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      